<template>
  <div
    v-wechat-title="
      ($route.meta.title = bookdetail.name
        ? bookdetail.name + '-详情-源石阅读'
        : '源石阅读')
    "
  >
    <div class="bookDetailBox" v-bind:style="{ minHeight: minheight + 'px' }">
      <Header></Header>
      <div class="readRecord clearfix">
        <div
          class="recordleft fl clearfix"
          v-if="isLogin && this.historyreward !== null"
        >
          <img src="~img/direction.png" class="fl" alt="" />
          <p class="fl">
            上次阅读：《{{ historyreward.bookName }}》{{
              historyreward.chapterName
            }}
          </p>
          <a
            class="fl"
            href="javaScript:"
            @click="historyRead(historyreward.bookId, historyreward.chapterId)"
            >继续阅读</a
          >
        </div>
        <!--  <div class="copyright fr clearfix" v-if="isLogin">
          <img class="fl" src="~img/copyright.svg" alt="" />
          <a href="#" class="fl">版权合作点我 >></a>
        </div> -->
      </div>
      <!-- 卡片简介：作者 作品 -->
      <bookIntro
        :detail="bookdetail"
        :authorDetail="authorDetail"
        :othersBook="othersBook"
        :hisChapters="hisChapters"
        :bookisShelf="bookisShelf"
        :isAuto="isAuto"
        @readbookId="readbookId"
        @useraddshelf="useraddshelf"
        @cancleAuto="cancleAuto"
      ></bookIntro>
      <!-- 作品信息 目录 -->
      <div class="detailCon">
        <div class="navbox clearfix">
          <div class="detailleft fl" v-if="bookdetail != null">
            <ul
              :class="{
                booknav: true,
                clearfix: true,
                disline: infoIndex == 1
              }"
            >
              <li
                v-for="(item, index) in booknav"
                :key="index"
                :class="{ active: index == infoIndex }"
                @click="chooseSeeOption(index)"
              >
                <p>
                  {{ item
                  }}<span v-if="index == 1"
                    >（{{ bookdetail.chapterNum }}章）</span
                  >
                </p>
                <span :class="{ line: true, fonts: index == 1 }"></span>
              </li>
            </ul>
            <div class="workInfomation" v-show="infoIndex == 0">
              <h3 class="clearfix">
                <p class="fl">作品简介</p>
              </h3>
              <p class="bookCon">
                {{ bookdetail.introduce }}
              </p>
            </div>
          </div>
          <!-- 三个列表切换组件 -->
          <div class="bookRecommend fr" v-show="infoIndex == 0">
            <bookRecommend
              :navlist="navlist"
              :navlists="navlists"
            ></bookRecommend>
          </div>
        </div>
        <!-- 一行6个推荐组件 -->
        <div class="workInfomation" v-show="infoIndex == 0">
          <h3 class="clearfix" v-if="shelf1.length > 0">
            <p class="fl">看这本书的人还看这些</p>
          </h3>
          <sixRecommend :booklist="shelf1" :isNewWindow="true"></sixRecommend>
        </div>

        <!-- 目录 -->
        <div class="bookDirectory" v-show="infoIndex == 1">
          <div
            v-for="(item, index) in booklist"
            :key="item.id"
            class="workInfomation"
          >
            <h3 class="clearfix volist">
              <p class="fl">{{ item.name }}</p>
            </h3>
            <ul class="clearfix">
              <li
                class="fl clearfix"
                v-for="(chapter, cindex) in item.chapters"
                :key="chapter.id"
                @click="goSee(bookId, chapter.id, chapter.free)"
              >
                <a href="javaScript:" class="fl ellipsis">
                  {{ chapter.name }}
                </a>
                <div class="vipbox fl" v-if="chapter.free == false">
                  <img class="vip" src="~img/book/vip@2x.png" />
                </div>
                <div
                  class="vipbox fl"
                  v-if="
                    booklist.length - 1 == index &&
                      item.chapters.length - 1 == cindex
                  "
                >
                  <img class="vip" src="~img/book/tag_new.svg" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <a href="javaScript:" @click="backTop" class="allgoTop" v-if="btnFlag">
          <img src="~img/book/top.svg" alt="" />
        </a>
      </div>
      <surePop :ApplyInfo="ApplyInfo" @passbind="passbind"></surePop>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {
  BookDetail,
  Bookmenu,
  lasthistory,
  addshelf,
  readstatus,
  buyAuto
} from "apiurl/book";
import { getToken } from "utils/storage";
import { getBookList, moreshelf } from "@/api/book";
export default {
  data() {
    return {
      bookId: null,
      navlist: ["推荐票", "人气榜", "热销榜"],
      booknav: ["作品信息", "目录"],
      infoIndex: 0,
      bookdetail: {}, // 书籍信息
      authorDetail: {}, //作者信息
      othersBook: [], //其他书
      booklist: [], // 书籍目录
      firstchapterId: null, //第一章id
      historyreward: null,
      isLogin: getToken(),
      bookDirectory: [],
      minheight: null,
      ApplyInfo: {
        isShow: false,
        title: "温馨提示",
        content: "此章节为收费章节,请到黑岩网阅读！",
        hint: "* www.heiyan.com",
        sure: "确定",
        cancle: "取消"
      },
      btnFlag: false, //顶部
      shelf1: [],
      shelf2: [],
      shelf3: [],
      shelf4: [],
      navlists: [],
      shelfBookList: [],
      hisChapters: null,
      bookisShelf: false,
      isAuto: false
    };
  },
  created() {
    this.$nextTick(() => {
      this.bookId = this.$route.params.id;
      // 获取书籍信息
      this.BookDetailInfo(this.$route.params.id);
      // 获取书籍目录
      //   this.BookMenu();
      // 获取阅读记录
      if (getToken()) {
        this.bookHistory();
      }
      // shelf
      this.bookShelf();
      this.getmoreshelf();
      // 获取某本书的阅读状态
      if (getToken()) {
        this.getReStatus();
      }
    });
  },
  watch: {
    $route(to) {
      this.bookId = to.params.id;
      return this.BookDetailInfo(this.bookId);
    }
  },
  methods: {
    // 选择查看
    chooseSeeOption(index) {
      this.infoIndex = index;
    },
    getmoreshelf() {
      moreshelf({ shelfId: "yuanshi_web_same_like" }).then(res => {
        if (res.success) {
          this.shelf1 = res.data.items;
          this.shelf1.forEach(items => {
            items.introduce = items.introduce.substring(0, 40) + "...";
          });
        }
      });
    },
    // 取消订阅
    cancleAuto() {
      buyAuto({ bookId: this.bookId, open: false }).then(res => {
        if (res.success) {
          this.$message({
            message: "自动订阅已关闭",
            type: "success"
          });
          this.getReStatus();
        }
      });
    },
    // 获取书籍详情信息
    async BookDetailInfo(id) {
      let res = await BookDetail(id);
      this.bookdetail = res.data.book;
      this.authorDetail = res.data.book.author;
      this.othersBook = res.data.othersBook;
      let tags = res.data.book.tags.split(",");
      this.bookdetail.tags = tags;
      this.booklist = res.data.menu;
      this.firstchapterId = this.booklist[0].chapters[0].id;
    },
    // 获取书籍目录
    async BookMenu() {
      let res = await Bookmenu({ bookId: this.bookId });
      this.booklist = res.data.menu;
      this.firstchapterId = this.booklist[0].chapters[0].id;
    },
    // 获取阅读记录
    async bookHistory() {
      let res = await lasthistory();
      if (res.success) {
        this.historyreward = res.data;
      }
    },
    // 去指定章节
    goSee(bookid, chapterid, free) {
      /*  if (free) {
              this.$router.push(`/book/${bookid}/${chapterid}`);
            } else {
              this.ApplyInfo.isShow = true;
            } */
      if (free) {
        localStorage.setItem("isfree", "true");
      } else {
        localStorage.setItem("isfree", "false");
      }
      this.$router.push(`/book/${bookid}/${chapterid}`);
    },
    // 去历史章节
    readbookId() {
      if (this.hisChapters !== null) {
        this.$router.push(`/book/${this.bookdetail.id}/${this.hisChapters.id}`);
      } else {
        this.$router.push(`/book/${this.bookdetail.id}/${this.firstchapterId}`);
      }
    },
    historyRead(bookid, chapterid) {
      this.$router.push(`/book/${bookid}/${chapterid}`);
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 80) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    // 加入书架
    async useraddshelf() {
      let res = await addshelf({ bookId: this.bookId });
      if (res.success) {
        this.bookisShelf = true;
        this.$message({
          message: "已成功加入书架",
          type: "success"
        });
      }
    },
    passbind() {
      this.ApplyInfo.isShow = false;
    },
    // 书架列表
    async bookShelf() {
      let list = await getBookList({ pageNo: 6, pageSize: 36 });
      if (list.success) {
        this.shelfBookList = list.data.items;
        this.shelf2 = this.shelfBookList.splice(0, 10);
        this.shelf3 = this.shelfBookList.splice(0, 10);
        this.shelf4 = this.shelfBookList.splice(0, 10);
        this.navlists.push(this.shelf2);
        this.navlists.push(this.shelf3);
        this.navlists.push(this.shelf4);
      }
    },
    // 获取读者阅读状态
    async getReStatus() {
      let res = await readstatus({ bookId: this.bookId });
      if (res.success) {
        this.hisChapters = res.data.hisChapter;
        this.bookisShelf = res.data.isShelf;
        this.isAuto = res.data.isAuto;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.minheight = document.documentElement.clientHeight - 200; //监听浏览器窗口变化
    window.onresize = () => {
      this.minheight = document.documentElement.clientHeight - 200;
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>

<style lang="stylus" scoped>
.bookDetailBox
    .readRecord
        height 48px
        width 1016px
        margin 0 auto
        .recordleft
            line-height 48px
            img
                width 16px
                height 16px
                margin-top 16px
                margin-right 4px
            p
                color #999999
                font-size 14px
                padding-right 15px
            a
                font-size 14px
                color #48A2DF
        .copyright
            line-height 48px
            img
                margin-right 4px
                margin-top 16px
            a
                color #555555
                font-size 14px
    .detailCon
        width 1017px
        margin 0 auto
        background rgba(255, 255, 255, 1)
        padding 23px 15px 10px
        box-sizing border-box
        h3
            background #fff
        .booknav
            width 744px
            border-bottom 1px solid #EDEDED
            padding-left 13px
            box-sizing border-box
            color #888888
            font-size 14px
            &.disline
                width 987px
            li
                position relative
                height 32px
                float left
                cursor pointer
                &:first-child
                    margin-right 36px
                &.active
                    .line
                        background rgba(72, 162, 223, 1)
                        &.fonts
                            margin-left 7px
                    p
                        font-size 16px
                        color #0CA3E5
                p
                    height 22px
                    vertical-align bottom
                    transition all 0.17s ease-in-out
                    span
                        font-size 13px
                .line
                    width 20px
                    height 3px
                    background #fff
                    border-radius 2px
                    position absolute
                    bottom 0
                    left 0
                    right 0
                    margin 0 auto
                    transition all 0.17s ease-in-out
        .workInfomation
            margin-top 19px
            margin-left 9px
            h3
                height 22px
                line-height 22px
                padding 0
                color rgba(51, 51, 51, 1)
                &.volist
                    border-bottom 1px solid #999
                    padding 0 0 12px
                img
                    width 22px
                    height 22px
                    margin-right 10px
                p
                    height 22px
                    line-height 22px
                    color #333333
                    font-size 16px
                    font-family PingFangSC
                    font-weight 600
            .bookCon
                width 687px
                font-size 14px
                font-family PingFangSC
                font-weight 400
                color rgba(0, 0, 0, 1)
                line-height 25px
                padding 10px 0 19px
                border-bottom 1px solid #EDEDED
        .bookDirectory
            padding-bottom 34px
            ul
                padding-bottom 10px
                &:last-child
                    padding-bottom 0px
                li
                    width 33.333%
                    border-bottom 1px solid #F7F7F7
                    height 45px
                    line-height 45px
                    a
                        font-size 14px
                        font-weight 400
                        max-width 70%
                        color #555555
                        &:hover
                            color #0ca3e5
                    .vip
                        width 20px
                        height 20px
                        margin-top 11px
                        margin-left 14px
.allgoTop
    position fixed
    bottom 210px
    right 50px
    width 30px
    img
        width 100%
</style>
